import React, { useRef, useImperativeHandle, forwardRef } from "react";
import SelectSearch, { SelectSearchOption } from "react-select-search";
import './custom-select-search.css';
interface SelectInputProps {
    options: { value: string; name: string }[];
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    isCross?: boolean;
    classes?: string;
    onChange: (value: string) => void;
    autoFocus?: boolean;
    defaultValue?: string | string[]
}
export interface SelectInputHandle {
    openDropdown: () => void;
}

const SelectInput = forwardRef<SelectInputHandle, SelectInputProps>(({
    options,
    value,
    disabled,
    classes,
    onChange,
    placeholder,
    isCross,
    autoFocus,
    defaultValue
}, ref) => {
    const containerRef = useRef<HTMLDivElement>(null);
    useImperativeHandle(ref, () => ({
        openDropdown: () => {
            const input = containerRef.current?.querySelector('input');
            input?.focus(); // focus triggers dropdown open
        }
    }));
    // const [filteredOptions, setFilteredOptions] = useState<SelectSearchOption[]>([]);
    // const lastQueryRef = useRef<string>("");
    // const handleFilter = (opts: SelectSearchOption[], query: string): SelectSearchOption[] => {
    //     lastQueryRef.current = query; // Store query for useEffect
    //     return opts.filter(option =>
    //         option.name.toLowerCase().includes(query.toLowerCase())
    //     );
    // };
    // useEffect(() => {
    //     const query = lastQueryRef.current;
    //     const filtered = options.filter(option =>
    //         option.name.toLowerCase().includes(query.toLowerCase())
    //     );
    //     setFilteredOptions(filtered);
    // }, [options, lastQueryRef.current]);

    // const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    //     if (e.key === "Tab" && !value) {
    //         e.preventDefault();
    //         if (filteredOptions.length > 0) {
    //             onChange(String(filteredOptions[0].value));
    //             setTimeout(() => {
    //                 const active = document.activeElement;
    //                 const next = active?.closest("div")?.nextElementSibling;
    //                 if (next instanceof HTMLElement) next.focus();
    //             }, 10);
    //         }
    //     }
    // };

    const handleClear = () => onChange('');
    const handleChange = (selectedOption: any) => {
        onChange(selectedOption);
    };

    return (
        <div
            className={`relative w-full ${classes}`}
            // onKeyDown={handleKeyDown}
            // tabIndex={0}
            ref={containerRef}
        >
            <SelectSearch
                options={options}
                value={value}
                disabled={disabled}
                onChange={handleChange}
                // filterOptions={[handleFilter]}
                search
                placeholder={placeholder}
                autoFocus={autoFocus}
                defaultValue={defaultValue}
            />
            {value && isCross && (
                <button
                    type="button"
                    onClick={handleClear}
                    className="absolute z-10 top-2 right-4 text-primary-red text-xl"
                >
                    x
                </button>
            )}
        </div>
    );
})
SelectInput.displayName = "SelectInput";
export default SelectInput;

